export function cbChunkContentQueryResponse(item, contentChallenges) {
    contentChallenges.push(item);
}
